import React from 'react';
import { Link } from 'react-router-dom';
import * as RT from '../../constants/Routing';
// import PlaceHolderImg from '../../assets/images/placeholder.png'
import PlaceHolderImg2x from '../../assets/images/placeholder@2x.png';

export default class TaskCard extends React.Component {
  constructor(props) {
    super(props);
    // console.log(this.props.task)

    // let limitDate = new Date(this.props.task.endDate + ' ' + this.props.task.endTime)
    // let currentDate = new Date()

    // console.log('タスクカード', this.props.task, limitDate, currentDate, limitDate > currentDate)
    this.state = {
      // FIXME: 正しいカテゴリーがレスポンスに追加されたら修正
      category: this.props.task.taskCategoryDetail[0]
        ? this.props.task.taskCategoryDetail[0].value
        : '',
      title: this.props.task.title,
      amount: this.props.task.fee,
      description: this.props.task.description,
      entryCount: this.props.task.participant.length,
      status: this.props.task.taskStatus,
      image: this.props.task.taskPhotoId || null
    };
  }

  _renderDate = () => {
    return `${this.props.task.startDate} ${this.props.task.startTime}-${this.props.task.endTime}`;
  };

  _renderImage = () => {
    if (this.state.image === null) {
      return (
        <div className="task-icon" style={{ backgroundImage: `url(${PlaceHolderImg2x})` }}></div>
      );
    }
    return (
      <div className="task-icon" style={{ backgroundImage: `url(${this.state.image})` }}></div>
    );
  };

  _renderDescription = () => {
    let desc = this.state.description;
    const descMaxSize = 200;
    if (!!desc && desc.length > descMaxSize) {
      desc = desc.slice(0, descMaxSize);
      desc += '...';
    }
    return desc;
  };

  render = () => {
    return (
      <div className={'task-card' + (!!this.props.taskOld ? ' old-task-card' : '')}>
        <div className="task-header">
          <p className="task-date">{this._renderDate()}</p>
          <span className="task-category">{this.state.category}</span>
          <h2 className="task-title">{this.state.title}</h2>
          <p>
            <span className="small">給与</span>
            <span className="task-price">
              {String(this.state.amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}円
            </span>
          </p>
          {this._renderImage()}
        </div>
        <p className="task-description">{this._renderDescription()}</p>
        <p className="task-entry-count">応募人数{this.state.entryCount}人</p>
        <div className="row">
          <div className="col-5">
            <p className="task-status">
              {(() => {
                if (!this.props.taskOld) {
                  return this.state.status;
                }
              })()}
            </p>
          </div>
          <div className="col-7" style={{ marginBottom: '1rem' }}>
            <Link
              className="btn btn-primary btn-md task-btn float-right"
              to={RT.TASK_SHOW_PATH.replace(/:task_id/, this.props.task.taskId)}
            >
              タスク詳細へ
            </Link>
          </div>
        </div>
      </div>
    );
  };
}
